// Tags are stored as either a JSON array string or a legacy comma-separated
// string, depending on when the row was written — normalize both to an array.
export const parseTagsSafely = (tags) => {
    if (!tags) return [];
    try {
        const parsed = JSON.parse(tags);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return typeof tags === 'string' ? tags.split(',').map(t => t.trim()).filter(t => t) : [];
    }
};
